import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import * as firebase from "firebase/app";
import UserRoleContent from "../auth/permissions/UserRoleContent";
import UIModal from "../ui/UIModal";
import { IAd } from "../../models/ad";
import ImageGalleryPaging from "./ImageGalleryPaging";
import DescriptionText from "../../laco-common/components/DescriptionText";
import { getUserProfile } from "../../laco-common/base/auth";
import { IUserProfileData } from "../../laco-common/base/models/user";
import { PhoneLinkWeb } from "../ui/PhoneLinkWeb";
import { EmailLinkWeb } from "../ui/EmailLinkWeb";
import DEFAULT_PROFILE_IMG from "../../laco-common/assets/images/user-gray.png";
import "./AdDetail.scss";

type AdDetailProps = {
	ads: IAd[];
	onClose: () => any;
} & RouteComponentProps;

type AdDetailState = {
	ad: IAd;
	userData: IUserProfileData;
	showSellerInfo: boolean;
};

export default class AdDetail extends Component<AdDetailProps, AdDetailState> {
	state = {
		ad: null,
		userData: null,
		showSellerInfo: false,
	};

	componentDidMount() {
		this.setAdDetailView();
	}

	componentWillUnmount() {
		this.setState({ ad: null });
	}

	componentDidUpdate(prevProps: AdDetailProps & RouteComponentProps, prevState: AdDetailState, snapshot) {
		if (prevProps.location.pathname !== this.props.location.pathname) {
			this.setAdDetailView();
		}
	}

	async setAdDetailView(ads: IAd[] = this.props.ads) {
		const pathSegments: string[] = this.props.location.pathname.split("/");
		if (pathSegments.length < 3) {
			this.setState({ ad: null });
			return;
		}
		const id: string = pathSegments[2];
		const ad: IAd = ads.find((a: IAd) => a.id === id);
		console.log("setAdDetailView() id:", id, ad);
		let userData: IUserProfileData;
		if (ad?.user_id) {
			try {
				userData = await getUserProfile(ad?.user_id, firebase.app());
			} catch (err) {
				console.error("Error getting userData:", err);
			}
		}
		this.setState({ ad, userData });
	}

	render() {
		if (!this.state.ad) return null;
		const ad: IAd = this.state.ad;
		const sellerName: string = `${this.state.userData?.first_name} ${this.state.userData?.last_name}`;

		return (
			<UserRoleContent roles={["admin", "user"]}>
				<UIModal
					title=" " //{this.state.ad?.name}
					pageTitle={ad.name}
					open={!!ad}
					onClose={() => {
						this.setState({ ad: null });
						this.props.onClose();
					}}
					showCloseIcon={true}
					noPadding={true}
					noContainer={true}
					className="image-fullscreen-overlay ad-detail-modal"
					contentClassName="ui-modal-content-fullscreen"
				>
					<div className="ad-detail-container d-flex flex-column flex-lg-row justify-content-between">
						<ImageGalleryPaging images={ad.media} />
						<div className="ad-detail-section mt-4">
							<h2>{ad.name}</h2>
							<h3 className="ad-price text-primary mb-1">{ad.priceFormatted}</h3>
							<h4 className="ad-date text-gray">{ad.dateFormatted}</h4>
							{!!ad.description && (
								<div className="description mt-2">
									<h5 className="mb-2-5 font-weight-bold">Description</h5>
									<DescriptionText text={ad.description} />
								</div>
							)}
							{!!this.state.userData && (
								<div className="description pt-4_5 contact-seller-container">
									<h5 className="mb-2-5 font-weight-bold">About the seller</h5>
									<div className="d-inline-flex align-items-center">
										<img src={DEFAULT_PROFILE_IMG} height={60} className="mr-2-5" />
										{sellerName}
									</div>
									<button
										className="btn btn-primary w-100 mt-2"
										onClick={() => this.setState({ showSellerInfo: true })}
									>
										Contact Seller
									</button>
									{this.state.showSellerInfo && (
										<UIModal
											title={sellerName}
											pageTitle={sellerName}
											open={this.state.showSellerInfo}
											onClose={() => this.setState({ showSellerInfo: false })}
											showCloseIcon={true}
											style={{ maxWidth: "600px" }}
											noPadding={true}
											className="pb-4"
										>
											<div className="d-flex flex-column seller-contact-details">
												<PhoneLinkWeb
													number={this.state.userData?.mobile_number}
													className="mb-2"
													orangeLink={true}
												/>
												<EmailLinkWeb
													email={this.state.userData?.primary_email}
													orangeLink={true}
												/>
											</div>
										</UIModal>
									)}
								</div>
							)}
						</div>
					</div>
				</UIModal>
			</UserRoleContent>
		);
	}
}
